import { ReactNode } from 'react';

interface ButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  className = '',
  type = 'button',
  disabled = false,
}: ButtonProps) {
  const baseClasses =
    'whitespace-nowrap cursor-pointer font-semibold transition-all duration-300 flex items-center justify-center tracking-wide';

  const variantClasses = {
    primary:
      'bg-gradient-to-r from-amber-500 to-yellow-400 text-gray-900 hover:from-amber-400 hover:to-yellow-300 shadow-lg shadow-amber-500/25 hover:shadow-amber-400/40',
    secondary:
      'bg-gray-800 text-amber-400 border border-amber-500/40 hover:bg-gray-700 hover:border-amber-400',
    outline:
      'border-2 border-amber-500 text-amber-400 hover:bg-amber-500 hover:text-gray-900',
    ghost:
      'text-amber-400 hover:text-amber-300 hover:bg-amber-500/10',
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm rounded-md',
    md: 'px-6 py-3 text-base rounded-lg',
    lg: 'px-8 py-4 text-lg rounded-lg',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      {children}
    </button>
  );
}
